import React, { useEffect, useState } from "react";
import { Grid, Card, CardContent } from "@mui/material";
import { TextCus } from "components";
import useMode from "hooks/useMode";
import { fontSize } from "theme";
import { useBDS, useUser } from "hooks";

const StatsCards = ({ onWardSales }) => {
  const [stats, setStats] = useState([
    { title: "成約物件数", value: "0", key: 'num_sold' },
    {
      title: "先月残掲載物件数",
      value: "0",
      key: 'num_remain'
    },
    {
      title: "新着物件数",
      value: "0",
      key: 'num_new'
    },
    {
      title: "SUUMOの掲載中物件数",
      value: "0",
      key: 'num_suumo'
    },
  ])
  const { onGetStats } = useBDS()
  const { ptype } = useUser()

  const mode = useMode();

  useEffect(() => {
    onGetStats(ptype, data => {
      if (data) {
        if (data?.ward_sales) {
          onWardSales?.(data?.ward_sales)
        }
        const stat = stats.map(e => {
          const el = {
            ...e,
            value: data[e.key]
          }
          return el
        });
        setStats(stat)
      }
    })
  }, [ptype])

  return (
    <Grid container spacing={2} mt={2}>
      {stats.map((stat, i) => (
        <Grid size={{ xs: 12, md: 3, sm: 8 }} key={i}>
          <Card sx={{ borderTop: `2px solid ${mode.primary}` }}>
            <CardContent>
              <TextCus color={mode.primary} fontSize={fontSize.md}>
                {stat.title}
              </TextCus>
              <TextCus variant="h6">{`${stat.value}`}</TextCus>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default StatsCards;
